import React from 'react';

import { type BlogMeta, WhatsNewArticle } from '@af/design-system-docs-ui';
import { Box, xcss } from '@atlaskit/primitives';

import header from './_images/header.png';
import Content from './_index.mdx';

export const meta: BlogMeta = {
	title: 'Implementing typography at scale: the journey behind the screens',
	author: 'Written by Rachel Radford and Eva Plaisted',
	description:
		'Meet Atlassian’s bold new typefaces and discover the journey that brought them to life.',
	image: header,
	publishDate: new Date(2025, 3, 10),
	readTime: '5 min read',
	type: 'Feature deep dive',
	href: '/whats-new/implementing-typography-at-scale',
	canonicalUrl:
		'https://www.atlassian.com/blog/design/implementing-typography-at-scale-the-journey-behind-the-screens',
};

const gridOverrideStyles = xcss({
	gridColumn: '12 span',
	paddingBlockEnd: 'space.200',
});

export default () => {
	return (
		<Box xcss={gridOverrideStyles}>
			<WhatsNewArticle meta={meta} content={<Content />} />
		</Box>
	);
};
